import ClientDetailsStore from './ClientDetailsStore'

const initializeClientDetails = () => new ClientDetailsStore()

export type { default as ClientDetailsStore } from './ClientDetailsStore'
export default initializeClientDetails
